<template>
  <div class="d-flex flex-column w-100 gap-2 fondo-terciario rounded-4 p-3 px-4 sombra-sm texto-principal" style="max-height: 90vh;">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <p class="m-0 fs-5 w-100" style="max-width: 130px;"><strong>{{ $t('roles') }}:</strong></p>
      <button @click="addRol" v-if="canAssignRoles" class="d-flex align-items-center gap-1 px-2 py-1 rounded-3 btn success-btn fs-7 fw-medium">
        <svg width="16" height="16" viewBox="2 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 12H18M12 6V18" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ $t('asignarRol') }}
      </button>
    </div>
    <div class="d-flex flex-column gap-3 scroll" style="height: auto; min-height: 200px; max-height: 50%;">
      <div v-for="personaRol in localPersona.RolesVisuales" :key="personaRol.IdRol" class="p-3 px-4 rounded-3 d-flex flex-column flex-md-row gap-3 align-items-center" :class="'fondo-'+personaRol.Estado.Color">
        <div class="d-flex align-items-center gap-3">
          <p class="fw-semibold  m-0">{{ $t(personaRol.Rol?.Rol.toLowerCase()) || 'Rol' }}</p>
          <span v-if="!(showStatusOptions === personaRol.IdRol)" @click="toggleStatusOptions(personaRol.IdRol)" class="d-flex align-items-center gap-2 rounded-pill px-2 py-1 fs-7 fw-medium"
              :class="'fondo-'+personaRol.Estado.Color+'-2'" style="cursor: pointer;">
            {{ $t(personaRol.Estado.Estado) }}
          </span>
        </div>
        <div v-if="showStatusOptions === personaRol.IdRol" class="d-flex align-items-center justify-content-between gap-2 w-100">
          <!-- <button v-if="!(showStatusOptions === personaRol.IdRol)" @click="toggleStatusOptions(personaRol.IdRol)" class="px-2 py-1 btn success-btn fw-medium fs-7 rounded-3">Cambiar Estado</button> -->
          <div class="d-flex flex-wrap align-items-center gap-2">
            <button v-for="estado in estados" :key="estado.idEstado" @click="changeStatus(personaRol.IdRol, estado)" class="px-2 py-1 btn fw-medium fs-7 rounded-pill border-3 texto-principal"
                :class="[estado.IdEstado == personaRol.IdEstado ? 'fondo-' + estado.Color + '-3' : 'fondo-transparente borde-'+ estado.Color + '-3',]">
              {{ $t(estado.Estado) }}
            </button>
            <div v-if="loadingEstados" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="@/assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
            </div>
          </div>
          <button @click="toggleStatusOptions(null)" class="px-2 py-1 btn secondary-btn fs-7 rounded-3 fw-medium">{{ $t('cancelar') }}</button>
        </div>
      </div>
    </div>
    <hr class="my-2 borde-gris">
    <p class="fw-semibold m-0">{{ $t('historialRoles') }}:</p>
    <div class="d-flex flex-column gap-2 scroll" style="height: auto; max-height: 50%;">
      <div v-for="hist in localPersona.HistorialRoles" :key="hist.FechaHora" class="d-flex align-items-center justify-content-between gap-3 p-2 px-3 rounded-3 fondo-secundario">
        <div class="d-flex flex-column align-items-start justifu-content-center">
          <div class="d-flex align-items-center gap-3">
            <p class="fw-medium m-0 fs-7">{{ $t(hist.Rol?.Rol.toLowerCase()) || 'Rol' }}</p>
            <span class="d-flex align-items-center gap-2 rounded-pill px-2 py-1 fs-7 fw-medium"
                :class="'fondo-'+hist.Estado.Color+'-2'">
              {{ $t(hist.Estado.Estado) }}
            </span>
          </div>
          <p v-if="hist.Motivo" class="fw-medium texto-secundario m-0 fs-8 text-start">{{ $t('motivo')+ ': ' +  hist.Motivo }}</p>
        </div>
        <div class="d-flex gap-2">
          <button type="button" class="btn p-1 d-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click="deleteHistorial(hist.IdHistorialPersonaRol)">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
              <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="tooltip-text">{{ $t('eliminar') }}</span>
          </button>
          <div v-if="loadingHistorial" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
            <img src="@/assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
          </div>
          <p class="m-0 fs-7">{{ formatDate(hist.FechaHora) }}</p>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showAssignModal" class="modal d-block" tabindex="-1" style="z-index: 3001;">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content w-100">
        <div class="d-flex justify-content-between p-2 pt-1 w-100">
          <h5 class="modal-title">{{ $t('asignarRol') }}</h5>
          <button type="button" class="btn p-0" @click="showAssignModal = false;">
            <svg width="20" height="20" viewBox="5 5 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect id="Rectangle" fill-rule="nonzero" x="0" y="0" width="24" height="24"></rect>
                <line x1="16.9999" y1="7" x2="7.00001" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
                <line x1="7.00006" y1="7" x2="17" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
              </g>
            </svg>
          </button>
        </div>
        <div class="modal-body pb-1">
          <div v-for="role in availableRoles" :key="role.IdRol" class="mb-2">
            <button @click="assignRole(role)" class="btn success-btn w-100">{{ $t(role.Rol.toLowerCase()) }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showAssignModal" class="modal-backdrop fade show" style="z-index: 3000;" @click="showAssignModal = false"></div>
  </template>

<script>
import { ref, watch, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'RolesSection',
  props: {
    persona: {
      type: Object,
      required: true
    },
    canAssignRoles: {
      type: Boolean,
      default: false
    },
    verRolesOcultos: {
      type: Boolean,
      default: false
    }
  },
  emits: ['updated'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const localPersona = ref({ ...props.persona });
    const allRoles = ref([]);
    const estados = ref([]);
    const showStatusOptions = ref(null);
    const loadingEstados = ref(false);
    const loadingHistorial = ref(false);
    const showAssignModal = ref(false);

    const fetchRoles = async () => {
      try {
        const response = await api.get(`api/Roles`);

        if(!props.verRolesOcultos){
          allRoles.value = response.data.filter(pr => !pr.Oculto);
        }else{
          allRoles.value = response.data;
        }
        //console.log(allRoles.value)
      } catch (error) {
        console.error('Error al obtener roles:', error);
      }
    };

    const fetchEstadosByRol = async (idRol) => {
      try {
        loadingEstados.value = true;
        const response = await api.get(`api/Roles/Estados/`+idRol);
        estados.value = response.data
        //console.log(estados.value)
        loadingEstados.value = false;
      } catch (error) {
        loadingEstados.value = false;
        console.error('Error al obtener roles:', error);
      }
    };

    const deleteHistorial = async (idHistorial) => {
      try {
        loadingHistorial.value = true;
        await api.delete(`api/Roles/historial/`+idHistorial);
        //console.log(estados.value)
        emit('updated');
        loadingHistorial.value = false;
      } catch (error) {
        loadingHistorial.value = false;
        console.error('Error al obtener roles:', error);
      }
    };
    
    const toggleStatusOptions = (rolId) => {
      fetchEstadosByRol(rolId)
      showStatusOptions.value = showStatusOptions.value === rolId ? null : rolId;
    };

    const changeStatus = async (idRol, nuevoEstado) => {
      try {
        var dto = {
          IdPersona: localPersona.value.IdPersona,
          IdRol: idRol,
          IdNuevoEstado: nuevoEstado.IdEstado,
          Motivo: '',
        }
        console.log(dto)
        await api.post(`api/Roles/manage-roles`, dto);
        // Update local data
        const personaRol = localPersona.value.HistorialRoles.find(pr => pr.IdRol === idRol);
        if (personaRol && personaRol.HistorialRoles) {
          personaRol.HistorialRoles.estado.nombre = nuevoEstado.Estado;
        }
        showStatusOptions.value = null;
        emit('updated');
      } catch (error) {
        console.error('Error al cambiar estado:', error);
        alert('Hubo un problema al cambiar el estado.');
      }
    };

    const addRol = () => {
      showAssignModal.value = true;
    };

    const availableRoles = computed(() => {
      const assignedRoleIds = localPersona.value.RolesVisuales?.map(pr => pr.IdRol) || [];
      return allRoles.value.filter(role => !assignedRoleIds.includes(role.IdRol));
    });

    const assignRole = async (role) => {
      try {
        const dto = {
          IdPersona: localPersona.value.IdPersona,
          IdRol: role.IdRol,
          IdNuevoEstado: '955EFA1D-C927-425B-A1F2-425DED375DBE',
          Motivo: 'Asignación de rol',
        };
        console.log(dto)
        await api.post(`api/Roles/manage-roles`, dto);
        showAssignModal.value = false;
        emit('updated');
      } catch (error) {
        console.error('Error al asignar rol:', error);
        alert('Hubo un problema al asignar el rol.');
      }
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    watch(() => props.persona, (newPersona) => {
      localPersona.value = { ...newPersona };
    }, { immediate: true });

    onMounted(async () => {
      await fetchRoles();
    });

    return {
      t,
      localPersona,
      allRoles,
      showStatusOptions,
      toggleStatusOptions,
      changeStatus,
      addRol,
      fetchEstadosByRol,
      estados,
      loadingEstados,
      showAssignModal,
      availableRoles,
      assignRole,
      formatDate,
      deleteHistorial,
      loadingHistorial,
    };
  }
};
</script>

<style>
.hover-bg-primary:hover {
  background-color: var(--bs-primary);
}

.hover-bg-light:hover {
  background-color: var(--bs-light);
}

.hover-bg-success:hover {
  background-color: var(--bs-success);
}

.hover-bg-danger:hover {
  background-color: var(--bs-danger);
}

.hover-bg-warning:hover {
  background-color: var(--bs-warning);
}

.hover-bg-info:hover {
  background-color: var(--bs-info);
}

.hover-shadow:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
</style>